module.exports = __webpack_public_path__ + "static/media/info-icon.ab86556e.svg";